document.addEventListener("DOMContentLoaded", function () {
  const button = document.querySelector(".scroll-to-top");

  if (button) {
    button.classList.remove("show");

    window.addEventListener("scroll", function () {
      if (window.scrollY > 200) {
        button.classList.add("show");
      } else {
        button.classList.remove("show");
      }
    });

    button.addEventListener("click", function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const productGrid = document.querySelector('.product-grid-layout');
  const listBtn = document.querySelector('.collection__layout-button[data-layout-mode="list"]');
  const gridBtn = document.querySelector('.collection__layout-button[data-layout-mode="grid"]');

  if (localStorage.getItem("layoutView") === "list") {
    productGrid.classList.add('grid-type--list_view');
  } else {
    productGrid.classList.remove('grid-type--list_view');
  }

  listBtn.addEventListener('click', function () {
    productGrid.classList.add('grid-type--list_view');
    localStorage.setItem("layoutView", "list");
  });

  gridBtn.addEventListener('click', function () {
    productGrid.classList.remove('grid-type--list_view');
    localStorage.setItem("layoutView", "grid");
  });
});




  // ✅ Initialize custom Add to Cart buttons safely
function initInCustomBtn() {
  document.querySelectorAll(".customBtn").forEach(function (button) {
    // 🔒 Prevent attaching event multiple times
    if (button.dataset.init === "true") return;
    button.dataset.init = "true";

    // 🧩 Add click listener only once
    button.addEventListener("click", function () {
      console.log("✅ Button clicked once only");

      let productBox = this.closest(".product-form");
      if (!productBox) return;

      let quantityInput = productBox.querySelector(".product-form__input.product-form__quantity");
      let selectElement = productBox.querySelector(".product-form__variants");

      if (!quantityInput || !selectElement) {
        console.warn("⚠️ Missing quantity or variant selector.");
        return;
      }

      const quantitybox = parseInt(quantityInput.value) || 1;
      const variantId = selectElement.value;

      // 🛒 Add product to cart
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantitybox
        })
      })
        .then(response => response.json())
        .then(data => {
          // console.log("✅ Added to cart:", data);
          this.classList.add("added");

          setTimeout(() => {
            this.classList.remove("added");
          }, 2000);

          closeDrwaerWhenAddItemInCollection();
        })
        .catch(error => {
          console.error("❌ Error adding to cart:", error);
        });
    });
  });
}

// 🟢 Initial call
initInCustomBtn();

// 🔁 Safe EventBus re-init (no duplicates due to dataset flag)
if (window.EventBus && typeof window.EventBus.subscribe === "function") {
  window.EventBus.subscribe("run-your-code-new", function () {
    initInCustomBtn();
    console.log("♻️ initInCustomBtn reinitialized (new)");
  });

  window.EventBus.subscribe("run-your-code", function () {
    initInCustomBtn();
    console.log("♻️ initInCustomBtn reinitialized (old)");
  });
} else {
  console.warn("⚠️ EventBus not found — make sure it's initialized before this script.");
}

// 🧰 Close drawer after adding item
function closeDrwaerWhenAddItemInCollection() {
  const interval = setInterval(() => {
    const slideCartoverlayDiv = document.querySelector(".qsc2-overlay");
    const slideCartDrawer = document.querySelector(".qsc2-drawer");
    const buttonNewCartClose = document.querySelector(".qsc2-drawer-header__close-button");

    if (slideCartDrawer && slideCartoverlayDiv) {
      slideCartoverlayDiv.classList.add("qsc2-overlay--hidden");
      slideCartDrawer.classList.add("qsc2-drawer--hidden");
      console.log("🟩 Drawer hidden");
    }

    if (buttonNewCartClose) {
      buttonNewCartClose.click();
    }
  }, 10);

  setTimeout(() => {
    clearInterval(interval);
    console.log("⏹️ Interval cleared after 1200ms");
  }, 1200);
}



document.addEventListener("DOMContentLoaded", function () {
  const resultsWrapper = document.querySelector("#SearchResultsWrapper");
  const loader = document.querySelector("#InfiniteScrollLoader");
  const urlHolder = document.querySelector("#data-pagination-url-set");

  if (!resultsWrapper || !urlHolder) return;

  let loading = false;
  let lastFetchedUrl = null;

  window.addEventListener("scroll", function () {
    const nextPageUrl = urlHolder.getAttribute("data-next-url");

    if (!nextPageUrl || nextPageUrl === lastFetchedUrl) return;

    if (
      window.innerHeight + window.scrollY >=
        document.body.offsetHeight - 300 &&
      !loading
    ) {
      loading = true;
      if (loader) loader.style.display = "block";

      fetch(nextPageUrl)
        .then((res) => res.text())
        .then((data) => {
          const parser = new DOMParser();
          const htmlDoc = parser.parseFromString(data, "text/html");

          const newResultsWrapper = htmlDoc.querySelector("#SearchResultsWrapper");
          const newUrlHolder = htmlDoc.querySelector("#data-pagination-url-set");

          if (newResultsWrapper) {
            resultsWrapper.insertAdjacentHTML("beforeend", newResultsWrapper.innerHTML);
          }

          if (newUrlHolder) {
            const newPaginateUrl = newUrlHolder.getAttribute("data-next-url");
            if (newPaginateUrl) {
              urlHolder.setAttribute("data-next-url", newPaginateUrl);
            } else {
              urlHolder.removeAttribute("data-next-url");
            }
          } else {
            urlHolder.removeAttribute("data-next-url");
          }

          lastFetchedUrl = nextPageUrl;
          if (loader) loader.style.display = "none";
          loading = false;
        })
        .catch(() => {
          if (loader) loader.style.display = "none";
          loading = false;
        });
    }
  });
});

/* ===== Shellback SEO: partial-match search fix (added 2026-06-23) =====
   Appends a "*" wildcard to each typed search term so partial words match.
   Example: "trans" -> "trans*" returns Transmitter, Transformer, Transceiver.
   Applies to every storefront search form (action="/search"). The existing
   exact-match behavior is preserved (a full word + "*" still matches).
   To revert: delete this block only. */
(function () {
  function wildcardify(value) {
    if (!value) return value;
    var terms = value.trim().split(/\s+/);
    var out = [];
    for (var i = 0; i < terms.length; i++) {
      var t = terms[i];
      if (t === "") continue;
      out.push(t.charAt(t.length - 1) === "*" ? t : t + "*");
    }
    return out.join(" ");
  }
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || typeof form.getAttribute !== "function") return;
    if ((form.getAttribute("action") || "").indexOf("/search") === -1) return;
    var input = form.querySelector('input[name="q"]');
    if (!input || !input.value) return;
    var nv = wildcardify(input.value);
    if (nv !== input.value) input.value = nv;
  }, true);
})();
